import { SET_USER_DATA } from '../../actions'

const initialState = {
  userData: null
}

export default function UserDataReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_DATA:
      console.log(action.payload)
      return {
        ...state,
        userData: action.payload
      }
    default:
      return state
  }
}
